import axios from 'axios';

export const HTTP_UNAVAILABLE_STATUSES = [403, 404] as const;
export const HTTP_DPIA_REQUEST_UNAVAILABLE_STATUSES = [403, 404, 409] as const;

export type UnavailableQueryResult = {
  error: unknown;
  status: number;
  unavailable: true;
};

/** Replaces the QueryClient snackbar `onError` for queries that already render the failure on the page. */
export const suppressQueryErrorToast = () => undefined;

export const isUnavailableQueryResult = (data: unknown): data is UnavailableQueryResult =>
  Boolean(data && typeof data === 'object' && 'unavailable' in data && (data as UnavailableQueryResult).unavailable === true);

export const unwrapAvailableQueryData = <T>(data: T | UnavailableQueryResult | undefined): T | undefined =>
  isUnavailableQueryResult(data) ? undefined : data;

export const getUnavailableStatus = (data: unknown): number | undefined => (isUnavailableQueryResult(data) ? data.status : undefined);

export const getHttpStatus = (error: unknown): number | undefined => (axios.isAxiosError(error) ? error.response?.status : undefined);

export const isHttpStatus = (error: unknown, statuses: readonly number[]): boolean => {
  const status = getHttpStatus(error);
  return status != null && statuses.includes(status);
};

export const catchHttpStatuses = async <T>(run: () => Promise<T>, statuses: readonly number[]): Promise<T | UnavailableQueryResult> => {
  try {
    return await run();
  } catch (error) {
    const status = getHttpStatus(error);
    if (status != null && statuses.includes(status)) {
      return { unavailable: true, status, error };
    }

    throw error;
  }
};
